const TABLE_HEADER = {
  START_DATE: "START DATE",
  APPLICATION_NO: "APPLICATION NO.",
  MERCHANT_NAME: "MERCHANT NAME",
  STATUS: "STATUS",
  SUB_STATUS: "SUB STATUS",
  USER: "USER",
  FUNDED: "FUNDED",
  NET_FUNDED: "NET FUNDED",
  FACTOR: "FACTOR",
  FUNDER: "FUNDER",
  BROKER: "BROKER",
  BANK_FEES: "BANK FEES",
  COMMISSION: "COMMISSION",
  AFFILIATED_BUSINESSES: "AFFILIATED BUSINESSES",
  OWNER_NAMES: "OWNER NAMES",
  DBAS: "DBAs",
} as const;

export default TABLE_HEADER;

export const BANK_STATEMENT_TABLE_HEADER = {
  DATE: "DATE",
  TYPE: "TYPE",
  DESCRIPTION: "DESCRIPTION",
  MEMO: "MEMO",
  BANK_NAME: "BANK NAME",
  ACCOUNT_NUMBER: "ACCOUNT #",
  AMOUNT: "AMOUNT",
  BALANCE: "TRUE",
  USE: "USE",
} as const;

export const BANK_ACCOUNT_TABLE_HEADER = {
  ACCOUNT_NUMBER: "Account Number",
  MONTH: "Month",
  BANK_NAME: "Bank Name",
  SOURCE: "Source",
};
